import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/FmsTypes";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";
import { transPgToPagination } from "@/views/base/app/appModel";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { invoiceManageService } from "@/views/invoice/manage/InvoiceManageService";
import { InvoiceApplySearch, InvoiceApply } from "@/views/invoice/manage/InvoiceManageTypes";
import { useDetailModel } from "../detailModel";

export const noBillDataModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    const { user: { shopCode }, beDs } = useGlobalModel();
    const { customerCode } = useDetailModel();

    //查询条件
    const [searchParam, setSearchParam] = useState<InvoiceApplySearch>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<InvoiceApply[]>([]);

    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedData, setSelectedData] = useState<InvoiceApply[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    //申请开票
    const [applyInvoiceVisible, setApplyInvoiceVisible] = useState(false);

    const onSearch = () => {
        loadData({ pageNum: 1 }, { ...searchParam })
        setSelectedRowKeys([]);
        setSelectedData([])
    }

    const onReset = () => {
        resetSearchParam()
    }

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: InvoiceApplySearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const resetSearchParam = () => {
        setSearchParam({});
        loadData(initPgCfg, {});
        setSelectedRowKeys([]);
        setSelectedData([])
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: InvoiceApplySearch = searchParam) => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            shopCode,
            partnerCode: customerCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }

        let { retData } = await invoiceManageService.invoiceApplyPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);

    }

    const getSelectedData = () => {
        return selectedData;
    }

    return {
        /***field***/
        initPgCfg,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        beDs,
        applyInvoiceVisible,
        /***method***/
        setSelectedData,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        getSelectedData,
        onSearch,
        onReset,
        setApplyInvoiceVisible
    }
});
